import studio from '@/modules/database/utils'
import { MergeOption } from '@/modules/database/utils/database'
import { Result, ResultVoid } from '@/modules/errorHandling/results'
import { CollectionNames } from '@/modules/database/utils/collectionNames'
import { Team } from '@/modules/teams/classes'
import { onMounted, ref, Ref } from '@vue/composition-api'
import useTeamDnsOverridesValidator from './teamDnsOverridesValidator'

const useTeamDnsOverrides = (team: Ref<Team>) => {
  const internationalOverride = ref('')
  const chinaOverride = ref('')

  onMounted(() => {
    internationalOverride.value = team.value.dnsOverrides?.linkPointerInternational ?? ''
    chinaOverride.value = team.value.dnsOverrides?.linkPointerChina ?? ''
  })

  const setLinkPointerOverrideInternational = async (): Promise<ResultVoid<'dns_override'>> => {
    const result = await studio.db.collection(CollectionNames.TEAMS).doc(team.value.id).set({
      dnsOverrides: {
        linkPointerInternational: internationalOverride.value
      }
    }, MergeOption.MERGE)
    if (!result.isSuccess) return Result.fail('dns_override', result.message)
    return Result.ok()
  }

  const setLinkPointerOverrideChina = async (): Promise<ResultVoid<'dns_override'>> => {
    const result = await studio.db.collection(CollectionNames.TEAMS).doc(team.value.id).set({
      dnsOverrides: {
        linkPointerChina: chinaOverride.value
      }
    }, MergeOption.MERGE)
    if (!result.isSuccess) return Result.fail('dns_override', result.message)
    return Result.ok()
  }

  return {
    ...useTeamDnsOverridesValidator({ chinaOverride, internationalOverride }),
    chinaOverride,
    internationalOverride,
    setLinkPointerOverrideChina,
    setLinkPointerOverrideInternational
  }
}

export default useTeamDnsOverrides
